import {combineReducers} from "redux";
import interactiveMap from './InteractiveMapReducer';
import staticTexts from './StaticTextsReducer';

export default combineReducers({
    interactiveMap,
    staticTexts,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js